/**
 * @description: 包厢类型设置
 * @author: hwx
 */
<template>
	<div class="room-type-wrap">
		<div class="rmt-list" v-show="showList">
			<h1>包厢类型设置</h1>
			<div class="row row-margin">
				<button type="button" class="btn btn-flat btn-middle btn-orange" @click="addRmt">新增包厢类型</button>
			</div>
			<div class="row">
				<label class="list-label-2">门店:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" ref="rmt_shop"></select>
				</div>
				<label class="list-label-4">包厢类型:</label>
				<div class="col-md-2">
					<input type="text" class="form-control" v-model="rmt_name" placeholder="请输入包厢类型">
				</div>
				<button type="button" class="btn btn-flat btn-small btn-orange pull-right" @click="queryList">查询</button>
			</div>
			<div class="table-responsive">
				<table class="table table-bordered table-hover" data-pagination="true" ref="rmt_list"></table>
			</div>
		</div>
		<div class="rmt-edit" v-show="!showList">
			<div class="page-tit">{{edit_tit}}</div>
			<div class="row">
				<label class="ctr-label-left">门店</label>
				<div class="col-md-5 ct-col">
					<select class="form-control" ref="edit_shop"></select>
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">包厢类型</label>
				<div class="col-md-5">
					<input class="form-control" placeholder="请输入包厢类型，例如：大包" v-model="edit_name">
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">容纳人数</label>
				<div class="col-md-5">
					<input class="form-control" placeholder="请输入可以容纳人数" v-model="edit_maxnum">
				</div>
			</div>
			<div class="row">
				<label class="edit-label-left">每日最大<br />预定包厢数</label>
				<div class="col-md-5">
					<input class="form-control input-readonly" v-model="edit_max_book" ref="edit_max_book" placeholder="请选择每日最大预定包厢数" readonly @click="openMaxBook()">
					<span class="selection-clear" @click="clearInput('edit_max_book')">×</span>
					<span class="span-arrow"><b></b></span>
				</div>
			</div>
			<div class="row">
				<label class="edit-label-left">每个主题每天<br />最大显示预定数</label>
				<div class="col-md-5">
					<input class="form-control input-readonly" v-model="edit_max_show" ref="edit_max_show" placeholder="每个主题每天最大显示预定数" readonly @click="openMaxShow()">
					<span class="selection-clear" @click="clearInput('edit_max_show')">×</span>
					<span class="span-arrow"><b></b></span>
				</div>
			</div>
			<div class="row">
				<button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backList">返回</button>
				<button type="button" class="btn btn-flat btn-middle btn-orange sub-margin" @click="editSave">保存</button>
			</div>
		</div>
		<!-- 每日最大显示预包厢数 -->
		<div class="use-time-wrap" ref="rmt_book_alert">
			<p>每日最大显示预包厢数：当前包厢类型来自微信端在线预定每日显示的预定的包厢总数。</p>
			<div class="row-margin">
				<input type="checkbox" v-model="rmt_book_unlimit" value="1">
				<label>不限制</label>
			</div>
			<div class="row">
				<input class="form-control" placeholder="请输入每日最大预定显示包厢总数" v-model="rmt_max_book" ref="rmt_max_book">
			</div>
		</div>
		<!-- 每个主题每天最大可预定数 -->
		<div class="use-time-wrap" ref="rmt_show_alert">
			<p>注释：微信端在线预定每个主题的每日可预定的最大包厢数。</p>
			<div class="row-margin">
				<input type="checkbox" v-model="rmt_show_unlimit" value="1">
				<label>不限制</label>
			</div>
			<div class="row">
				<input class="form-control" placeholder="请输入每日最大预定显示包厢总数" v-model="rmt_max_show" ref="rmt_max_show">
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	export default {
		name: '',
		data() {
			return {
				showList: true,
				modify: '1',

				rmt_name: '',

				edit_id: '',
				edit_tit: '',
				edit_name: '',
				edit_maxnum: '',
				edit_max_book: '',
				rmt_book_unlimit: '',
				rmt_max_book: '',
				edit_max_show: '',
				rmt_show_unlimit: '',
				rmt_max_show: '',
			}
		},
		watch: {
			rmt_book_unlimit: {
				handler: function(val, oldVal) {
					if(val == '1') {
						$(this.$refs.rmt_max_book).attr('disabled', true);
					} else {
						$(this.$refs.rmt_max_book).attr('disabled', false);
					}
				},
				deep: true
			},
			rmt_show_unlimit: {
				handler: function(val, oldVal) {
					if(val == '1') {
						$(this.$refs.rmt_max_show).attr('disabled', true);
					} else {
						$(this.$refs.rmt_max_show).attr('disabled', false);
					}
				},
				deep: true
			},
		},
		mounted: function() {
			this.getShopData();
		},
		methods: {
			// 门店
			getShopData: function() {
				const _this = this;

				Vue.axios.post('PublicData/api_getShopListByPurview', {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						let arr = [];
						res.data.response.result.forEach(v => {
							arr.push({ id: v.id, text: v.name });
						});
						$(_this.$refs.rmt_shop).select2({
							data: arr,
							width: '100%'
						});
						$(_this.$refs.rmt_shop).val(arr[1].id).trigger('change');
						_this.initTable();

						arr.shift();
						$(_this.$refs.edit_shop).select2({
							data: arr,
							width: '100%'
						});
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},
			openMaxBook: function() {
				const _this = this;

				if(_this.rmt_book_unlimit != '1') {
					_this.rmt_max_book = _this.edit_max_book;
				} else {
					_this.rmt_max_book = '';
				}
				layer.confirm('', {
					type: 1,
					skin: 'public-alert-skin',
					btn: ['确定', '取消'], // 按钮
					title: '每日最大预定包厢数',
					area: ['450px', ''], // 宽高
					content: $(_this.$refs.rmt_book_alert)
				}, function() {
					if(_this.rmt_book_unlimit == '1') {
						_this.edit_max_book = '不限制';
					} else {
						_this.edit_max_book = _this.rmt_max_book;
					}
					layer.closeAll();
				});
			},
			openMaxShow: function() {
				const _this = this;

				if(_this.rmt_show_unlimit != '1') {
					_this.rmt_max_show = _this.edit_max_show;
				} else {
					_this.rmt_max_show = '';
				}
				layer.confirm('', {
					type: 1,
					skin: 'public-alert-skin',
					btn: ['确定', '取消'], // 按钮
					title: '每日最大预定包厢数',
					area: ['450px', ''], // 宽高
					content: $(_this.$refs.rmt_show_alert)
				}, function() {
					if(_this.rmt_show_unlimit == '1') {
						_this.edit_max_show = '不限制';
					} else {
						_this.edit_max_show = _this.rmt_max_show;
					}
					layer.closeAll();
				});
			},

			// 初始化列表
			initTable: function() {
				const _this = this;
				$(_this.$refs.rmt_list).bootstrapTable('destroy');
				$(_this.$refs.rmt_list).bootstrapTable({
					pageNumber: 1,
					pageSize: 15,
					pageList: [],
					pagination: true,
					ajax: function(params) {
						_this.getRmtList(params);
					},
					sidePagination: "server",
					columns: [{
						field: "shop_name",
						title: "门店",
						width: "10%",
						valign: 'middle'
					}, {
						field: "name",
						title: "包厢类型",
						width: "10%",
						valign: 'middle'
					}, {
						field: "galleryful",
						title: "可容纳人数",
						width: "10%",
						valign: 'middle'
					}, {
						field: "max_book_day_num",
						title: "每日最大<br />预定包厢数",
						width: "10%",
						valign: 'middle',
						formatter: function(value, row, index) {
							if(value == '-1') {
								return '不限制';
							} else {
								return value;
							}
						}
					}, {
						field: "max_book_theme_num",
						title: "每个主题每天<br />最大显示预定数",
						width: "10%",
						valign: 'middle',
						formatter: function(value, row, index) {
							if(value == '-1') {
								return '不限制';
							} else {
								return value;
							}
						}
					}, {
						title: "操作",
						width: "15%",
						valign: 'middle',
						events: {
							'click .edit': function(e, value, row, index) {
								_this.modify = 2;
								_this.edit_id = row.id;
								_this.edit_tit = '修改包厢类型';
								$(_this.$refs.edit_shop).val(row.shop_id).trigger('change');
								$(_this.$refs.edit_shop).prop('disabled', true);
								_this.edit_name = row.name;
								_this.edit_maxnum = row.galleryful;
								if(row.max_book_day_num == '-1') {
									_this.edit_max_book = '不限制';
									_this.rmt_book_unlimit = '1';
									_this.rmt_max_book = '';
								} else {
									_this.edit_max_book = row.max_book_day_num;
									_this.rmt_book_unlimit = '';
									_this.rmt_max_book = row.max_book_day_num;
								}
								if(row.max_book_theme_num == '-1') {
									_this.edit_max_show = '不限制';
									_this.rmt_show_unlimit = '1';
									_this.rmt_max_show = '';
								} else {
									_this.edit_max_show = row.max_book_theme_num;
									_this.rmt_show_unlimit = '';
									_this.rmt_max_show = row.max_book_theme_num;
								}
								_this.showList = false;
							},
							'click .del': function(e, value, row, index) {
								layer.confirm('删除后不可恢复，确定删除吗？', {
									btn: ['确定', '取消']
								}, function() {
									_this.delRmt(row.id);
								});
							}
						},
						formatter: function(value, row, index) {
							return '<span class="text-blue edit">修改</span>&nbsp;&nbsp;&nbsp;<span class="text-blue del">删除</span>'
						}
					}]
				});
			},
			getRmtList: function(params) {
				let _this = this,
					pageNumber = 1;
				if(params != "" && params.data.offset != 0) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				Vue.axios.post('Setting/getRoomTypeList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": pageNumber,
							"page_size": params.data.limit,
							"shop_id": $(_this.$refs.rmt_shop).val(),
							"name": _this.rmt_name
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						params.success({
							total: res.data.response.result.total,
							rows: res.data.response.result.rows
						});
					} else {
						Vue.timeoutfun(res.data.response.result_status,_this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
			// 查询
			queryList: function() {
				this.initTable();
			},
			// 打开新增
			addRmt() {
				const _this = this;
				_this.modify = '1';
				_this.edit_tit = '新增包厢类型';
				$(_this.$refs.edit_shop).val('').trigger('change');
				$(_this.$refs.edit_shop).prop('disabled', false);
				_this.edit_name = '';
				_this.edit_maxnum = '';
				_this.edit_max_book = '';
				_this.rmt_book_unlimit = '';
				_this.rmt_max_book = '';
				_this.edit_max_show = '';
				_this.rmt_show_unlimit = '';
				_this.rmt_max_show = '';
				_this.showList = false;
			},
			// 返回列表
			backList() {
				this.showList = true;
			},
			// 保存
			editSave() {
				const _this = this;

				let url = "Setting/addRoomType";
				let max_book_day_num = '',
					max_book_theme_num = '';
				if(_this.rmt_book_unlimit == '1') {
					max_book_day_num = '-1';
				} else {
					max_book_day_num = _this.edit_max_book;
				}
				if(_this.rmt_show_unlimit == '1') {
					max_book_theme_num = '-1';
				} else {
					max_book_theme_num = _this.edit_max_show;
				}
				let data = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"shop_id": $(_this.$refs.edit_shop).val(),
							"name": _this.edit_name,
							"galleryful": _this.edit_maxnum,
							"max_book_day_num": max_book_day_num,
							"max_book_theme_num": max_book_theme_num
						}
					},
					"comment": ""
				};
				if(_this.modify == '2') {
					url = Vue.ctUrl + "Setting/updateRoomType";
					data.request.param.id = _this.edit_id;
				}
				Vue.axios({
					method: 'post',
					url: url,
					data: data
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						layer.msg('操作成功');
						$(_this.$refs.rmt_list).bootstrapTable('refresh');
						_this.showList = true;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},
			// 删除
			delRmt: function(id) {
				const _this = this;

				Vue.axios.post('Setting/delRoomType', {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"id": id
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						layer.msg('删除成功');
						$(_this.$refs.rmt_list).bootstrapTable("refresh");
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},
		}

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	.room-type-wrap {
		.rmt-edit {
			.edit-label-left {
				float: left;
				width: 120px;
				margin: 0 0 30px;
				color: #5e5e5e;
				font-size: 14px;
				text-align: right;
				font-weight: normal;
			}
		}
		.use-time-wrap {
			p {
				color: #FF0707;
			}
		}
	}
</style>